import theme from "@/theme";

export const styles = {
  home: {
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    minWidth: 0,
    width: "100%",
  },
  filterWrapper: {
    minHeight: "64px",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "8px",
    rowGap: "8px",
    borderBottom: "1px solid #eaecef",
    backgroundColor: "#ffffff",
    padding: "16px 24px",
    boxSizing: "border-box",
  },
  filterButton: {},

  filterButtonSelected: ({ selected }: { selected: boolean }) => ({
    borderRadius: "1.375rem",
    fontSize: "1rem",
    lineHeight: "1.25rem",
    padding: "8px 16px",
    textTransform: "none",
    color: selected ? "white" : theme.palette.custom.blueGray900,
    backgroundColor: selected ? theme.palette.custom.mainBlue : theme.palette.custom.mainWhite,
  }),

  filterSelectButton: ({ selected }: { selected: boolean }) => ({
    borderRadius: 20,
    textTransform: "none",
    padding: "6px 16px",
    border: "1px solid #d0d7de",
    color: selected ? "white" : "#24292f",
    fontSize: "1rem",
    backgroundColor: selected ? theme.palette.custom.mainBlue : theme.palette.custom.mainWhite,
    "&:hover": {
      backgroundColor: selected ? "none" : "#f4f5f6",
    },
  }),

  showMoreBox: {
    height: "3.75rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // marginBottom: "0.75rem",
  },
  showMoreButton: {
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
  },

  //!Post

  cardWrapper: {
    display: "flex",
    gap: "12px",
    flexDirection: "row",
    padding: "16px 20px",
    bgcolor: theme.palette.custom.mainWhite,
    boxShadow: "none",
    borderRadius: "0",
    borderBottom: "1px solid #F5F5F5",
    width: "100%",
    position: "relative",
    zIndex: 0,
    "&:focus": {
      outline: "none",
    },

    "&:focus-visible": {
      outline: "none",
    },
  },

  postSelectDropdownMenu: {
    sx: {
      marginTop: "9px",
      marginLeft: "5px",
      borderRadius: "8px",
      padding: "0px",
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 0px 16px 0px #0000001A",
      maxWidth: "156px",
      minWidth: "154px",
    },
  },
  menuOptionText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontStyle: "Medium",
    fontSize: "14px",
    leadingTrim: "NONE",
    lineHeight: "20px",
    letterSpacing: "0%",
    verticalAlign: "middle",
  },
  cardContent: (paid: boolean) => ({
    bgcolor: paid ? "#F4F5F6" : "FFF",
    borderRadius: "16px",
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "0.625rem",
    minWidth: 0,
  }),

  postContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    wordBreak: "break-word",
    overflowWrap: "anywhere",

    "& img, & video, & iframe": {
      maxWidth: "100%",
      height: "auto",
      display: "block",
    },
  },
  postContentLong: {
    width: "100%",
    padding: "10px ",
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    fontSize: "15px",

    "& img, & video, & iframe": {
      maxWidth: "100%",
      height: "auto",
      objectFit: "fill",
      display: "block",
    },
    "& .preview-content-post > br": {
      display: "block",
      height: "22.5px",
    },
  },

  iconButtons: {
    width: "22px",
    height: "22px",
    marginLeft: "auto",
    display: "flex",
    gap: "0.25rem",
  },
};
